import { storeToRefs } from "pinia";
import { ref } from "vue";
import appApi from "@/services/api/";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import usePublicStore from "@/store/public";
import useStoreCotizaciones from "@/store/cotizaciones";
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");

export const useValidacionCelular = () => {
  const { mostrarPasoDatos, mostrarPasoDatosEmpresa } = storeToRefs(
    usePublicStore()
  );
  const btnLoading = ref(false);

  const sendSMS = async () => {
    const form = document.getElementById("formCelular");
    const formData = new FormData(form);
    btnLoading.value = true;
    try {
      const response = await appApi().post(
        `public/cotizaciones/enviarSMS`,
        formData
      );
      const { status, message } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");

      const showModal = (modalId) => {
        const myModal = new bootstrap.Modal(document.getElementById(modalId));
        myModal.show();
      };

      showModal("modalCodigo");
      /* showPhoneSection.value = false;
      showCodeSection.value = true; */
    } catch (e) {
      exceptionRequestMsg(e);
    } finally {
      btnLoading.value = false;
    }
  };

  const simularSMS = () => {
    const showModal = (modalId) => {
      const myModal = new bootstrap.Modal(document.getElementById(modalId));
      myModal.show();
    };

    showModal("modalCodigo");
  };

  return {
    btnLoading,
    sendSMS,
    simularSMS,
  };
};

export const useValidacionCodigo = () => {
  const {
    mostrarPasoDatos,
    mostrarPasoDatosEmpresa,
    Close,
    leyendaPaso,
    state,
  } = storeToRefs(usePublicStore());
  const btnLoading = ref(false);

  const validateCode = async () => {
    btnLoading.value = true;
    const form = document.getElementById("formCodigo");
    const formData = new FormData(form);
    formData.append("celular", state.value.celular);
    try {
      const response = await appApi().post(
        `public/cotizaciones/validateCode`,
        formData
      );

      const { status, message } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");

      mostrarPasoDatos.value = false;
      mostrarPasoDatosEmpresa.value = true;
      leyendaPaso.value = "Paso 2: Detalles personales y de la empresa";

      Close.value.click();
    } catch (e) {
      exceptionRequestMsg(e);
    } finally {
      btnLoading.value = false;
    }
  };

  const nextInput = ({ value, id }) => {
    if (value == "") return;
    const idNext = parseInt(id) + 1;
    document.getElementById(idNext).focus();
  };

  return {
    btnLoading,
    validateCode,
    nextInput,
  };
};

export const useDatosGenerales = () => {
  const {
    formGenerales,
    mostrarPasoDatosEmpresa,
    mostrarPasoDatosActivo,
  } = storeToRefs(usePublicStore());

  const showMoral = ref(false);
  const btnCargando = ref(false);

  const submitGenerales = () => {
    btnCargando.value = true;
    try {
      if (
        document.getElementById("tipo_persona") == "MORAL" &&
        document.getElementById("empresa") == ""
      ) {
        showToast("Ingrese el nombre de la empresa", "warning");
        return;
      }

      formGenerales.value = document.getElementById("formGeneral");
      mostrarPasoDatosEmpresa.value = false;
      mostrarPasoDatosActivo.value = true;
    } catch (e) {
      exceptionRequestMsg(e);
    } finally {
      btnCargando.value = false;
    }
  };

  const togglePersonaMoral = (tipo_persona) => {
    if (tipo_persona == "MORAL") {
      showMoral.value = true;
    } else {
      showMoral.value = false;
      document.getElementById("empresa").value("");
      document.getElementById("representante_legal").value("");
    }
  };

  return {
    showMoral,
    togglePersonaMoral,
    submitGenerales,
    btnCargando,
  };
};

export const useDatosCotizacion = () => {
  const {
    formGenerales,
    mostrarPasoCotFinalizada,
    mostrarPasoDatosActivo,
    cotizacionFinal,
    state,
  } = storeToRefs(usePublicStore());
  const btnLoading = ref(false);
  const { incluyeSeguro } = storeToRefs(useStoreCotizaciones());

  const submitCotizacion = async () => {
    btnLoading.value = true;
    const form = document.getElementById("formCotizacion");
    const formData = new FormData(form);
    const combinedFormData = new FormData();

    for (let i = 0; i < formGenerales.value.length; i++) {
      combinedFormData.append(
        formGenerales.value[i].name,
        formGenerales.value[i].value
      );
    }

    for (const pair of formData.entries()) {
      combinedFormData.append(pair[0], pair[1]);
    }
    combinedFormData.append("user_id", 111); // <----- ID del usuario para la cotización web pública!!
    combinedFormData.append("celular", state.value.celular);
    combinedFormData.append("correo", state.value.correo);
    combinedFormData.append("incluye_seguro", incluyeSeguro.value)

    try {
      const response = await appApi().post(
        `public/cotizaciones/store`,
        combinedFormData
      );

      const { status, message, cotizacion } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");
      cotizacionFinal.value = cotizacion;
      mostrarPasoDatosActivo.value = false;
      mostrarPasoCotFinalizada.value = true;
    } catch (e) {
      exceptionRequestMsg(e);
    } finally {
      btnLoading.value = false;
    }
  };

  return {
    submitCotizacion,
    btnLoading,
  };
};

export const usePasos = () => {
  const classPaso = (val) => {
    return val ? "text-warning" : "";
  };

  return {
    classPaso,
  };
};
